import { EnhancedUploadArea } from "../../storage/EnhancedUploadArea";
import { useImageUpload } from "@/hooks/useImageUpload";

interface ImageUploadProps {
  label: string;
  currentPath?: string;
  onPathChange: (path: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export const ImageUpload = ({
  label,
  currentPath,
  onPathChange,
  disabled,
  placeholder,
}: ImageUploadProps) => {
  const { uploading, currentUrl, uploadFile, clearImage, handleUrlInput } =
    useImageUpload({
      bucketName: "character-images",
      onPathChange,
      currentPath,
    });

  const handleFileUpload = (file: File) => {
    uploadFile(file);
  };

  const handleFileSelect = (bucketName: string, fileName: string) => {
    // Convert the selected file to a path format
    const filePath = fileName.startsWith("/") ? fileName : `/${fileName}`;
    onPathChange(filePath);
  };

  const handlePathChange = (path: string) => {
    handleUrlInput(path);
  };

  return (
    <div className="space-y-2">
      <EnhancedUploadArea
        label={label}
        onFileUpload={handleFileUpload}
        onFileSelect={handleFileSelect}
        onPathChange={handlePathChange}
        uploading={uploading}
        acceptedTypes={[".jpg", ".jpeg", ".png", ".webp", ".gif"]}
        allowedBuckets={["character-images"]}
        showBrowseOption={true}
        showPathInput={true}
        currentPath={currentPath || ""}
      />

      {/* Preview */}
      {currentUrl && (
        <div className="mt-2">
          <div className="relative inline-flex items-center justify-center h-20 w-32 rounded border overflow-hidden bg-gray-50">
            <img
              src={currentUrl}
              alt="Image preview"
              className="max-h-full max-w-full"
              onError={(e) => {
                console.error("Failed to load image preview");
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
